import CustomCheckBox from "@/components/CustomCheckBox/CustomCheckBox.vue"
import UploadImage from "@/components/UploadImage/UploadImage.vue"
import CustomInput from "@/components/CustomInput/CustomInput.vue"
import PostCover from "@/components/PostCover/PostCover.vue"
import CustomDropdownBorder from "@/components/CustomDropdownBorder/CustomDropdownBorder.vue"
import CustomTooltipLeft from "@/components/CustomTooltipLeft/CustomTooltipLeft.vue"
import AccordionSocial from "@/components/AccordionSocial/AccordionSocial.vue"
import StatisticsPage from "@/views/StatisticsPage/StatisticsPage.vue";
import {mapGetters} from "vuex";

export default {
    name: 'changeProject',
    components: {
        CustomCheckBox,
        UploadImage,
        CustomInput,
        PostCover,
        CustomDropdownBorder,
        CustomTooltipLeft,
        AccordionSocial,
        StatisticsPage
    },
    data() {
        return {
            allRight: false,
            steps: {
                name: false,
                content: false,
                design: false,
                gate: false,
                pixel: false,
                confirm: false,
            },
            buttons: [
                {id: 1, name: 'Download'},
                {id: 2, name: 'Get content'},
                {id: 3, name: 'Get link'},

            ],
            colorScheme: [
                {id: 1, name: 'Light scheme', value: false},
                {id: 2, name: 'Dark scheme', value: true}
            ],
            listBubble: [
                {name: 'Account', src: '/account'},
                {name: 'Log out', src: '/logout'},
            ],
            flag: '',
            email: '',
            projectName: '',
            page: {
                title: '',
                description: '',
                button: 1,
                buttonText: 'Download',
                cover: '',
                dark: false,
                steps: [
                    {
                        sub_id: 1,
                        status: false,
                        name: 'E-mail capture',
                        check: {
                            inputs: [],
                            fillable: false,
                            type: 'And',
                            visitor: '',
                            requiredOne: false,
                            skippable: false
                        },
                        icon: 'email'
                    },
                    {
                        sub_id: 2,
                        status: false,
                        name: 'Facebook',
                        check: {
                            inputs: [],
                            fillable: true,
                            type: 'And',
                            visitor: '',
                            requiredOne: false,
                            skippable: false
                        },
                        icon: 'facebook'
                    },
                    {
                        sub_id: 3,
                        status: false,
                        name: 'Instagram',
                        check: {
                            inputs: [],
                            fillable: true,
                            type: 'And',
                            visitor: '',
                            requiredOne: false,
                            skippable: false
                        },
                        icon: 'instagram'
                    },
                    {
                        sub_id: 4,
                        status: false,
                        name: 'Twitter',
                        check: {
                            inputs: [],
                            fillable: true,
                            type: 'And',
                            visitor: '',
                            requiredOne: false,
                            skippable: false
                        },
                        icon: 'twitter'
                    },
                    // {
                    //     sub_id: 5,
                    //     status: false,
                    //     name: 'What\'s App',
                    //     check: {
                    //         inputs: [],
                    //         fillable: false,
                    //         type: 'And',
                    //         visitor: '',
                    //         requiredOne: false,
                    //         skippable: false
                    //     },
                    //     icon: 'whatsapp'
                    // },
                    {
                        sub_id: 6,
                        status: false,
                        name: 'YouTube',
                        check: {
                            inputs: [],
                            fillable: true,
                            visitor: '',
                            type: 'And',
                            requiredOne: false,
                            skippable: false
                        },
                        icon: 'youtube'
                    }
                ]
            },
            text: '',
            url: '',
            password: '',
            visibleB: true,
            tooltipDropdown: [
                {option: 'Profile settings', href: "/profile-settings"},
                {option: 'Logout', href: "/logout"},
            ],
            pixel: '',
            list: [],
            selected: {
                button: {id: 1, name: 'Download'},
                colorScheme: {id: 1, name: 'Light scheme', value: false}
            },
            projectNameTouch: false,
            titleTouch: false,
            urlTouch: false,
            pixelTouch: false,
            descTouch: false,
            defaultSteps: [
                {
                    sub_id: 1,
                    status: false,
                    name: 'E-mail capture',
                    check: {
                        inputs: [],
                        fillable: false,
                        type: 'And',
                        visitor: '',
                        requiredOne: false,
                        skippable: false
                    },
                    icon: 'email'
                },
                {
                    sub_id: 2,
                    status: false,
                    name: 'Facebook',
                    check: {
                        inputs: [],
                        fillable: true,
                        type: 'And',
                        visitor: '',
                        requiredOne: false,
                        skippable: false
                    },
                    icon: 'facebook'
                },
                {
                    sub_id: 3,
                    status: false,
                    name: 'Instagram',
                    check: {
                        inputs: [],
                        fillable: true,
                        type: 'And',
                        visitor: '',
                        requiredOne: false,
                        skippable: false
                    },
                    icon: 'instagram'
                },
                {
                    sub_id: 4,
                    status: false,
                    name: 'Twitter',
                    check: {
                        inputs: [],
                        fillable: true,
                        type: 'And',
                        visitor: '',
                        requiredOne: false,
                        skippable: false
                    },
                    icon: 'twitter'
                },
                // {
                //     sub_id: 5,
                //     status: false,
                //     name: 'What\'s App',
                //     check: {
                //         inputs: [],
                //         fillable: false,
                //         type: 'And',
                //         visitor: '',
                //         requiredOne: false,
                //         skippable: false
                //     },
                //     icon: 'whatsapp'
                // },
                {
                    sub_id: 6,
                    status: false,
                    name: 'YouTube',
                    check: {
                        inputs: [],
                        fillable: true,
                        visitor: '',
                        type: 'And',
                        requiredOne: false,
                        skippable: false
                    },
                    icon: 'youtube'
                }
            ],
            update: false,
        }
    },
    methods: {
        coverUpload(data) {
            this.steps.design = !!(this.page.description && this.page.title && this.page.cover);
            this.page.cover = data
        },
        accordion: (event) => {
            event.currentTarget.closest('.accordion-item').classList.toggle('accordion-item-active');
        },
        nextStep: (event) => {
            event.preventDefault();
            let newId = parseInt(event.currentTarget.id, 10) + 1
            let next = document.getElementById(newId)
            event.currentTarget.closest('.accordion-item').classList.toggle('accordion-item-active')
            next.closest('.accordion-item').classList.toggle('accordion-item-active')
        },
        switcherFlag(flag) {
            this.flag = flag
        },
        inputEmail(data) {
            this.email = data
        },
        inputText(data) {
            this.text = data
        },
        inputProjectName(data) {
            this.projectName = data
            this.page.name = data.inp
            if (!data.invalide && !data.error) {
                this.steps.name = true
            } else {
                this.steps.name = false
            }
            localStorage.newProjectName = JSON.stringify(this.projectName)
        },
        inputUrl(data) {
            if (!data.invalide && !data.error) {
                this.steps.content = true
            } else {
                this.steps.content = false
            }
            this.url = data
            this.page.url = data.inp
            localStorage.newUrl = JSON.stringify(this.url)
        },
        inputPageTitle(data) {
            if (!data.invalide) {
                if (this.page.description && this.page.title) {
                    this.steps.design = true
                } else {
                    this.steps.design = false
                }
                this.page.title = data.inp
            } else {
                this.steps.design = false
                this.page.title = ''
            }
            localStorage.newPageTitle = JSON.stringify(this.page.title)
        },
        checkDesc() {
            this.descTouch = true
            if (this.page.description && this.page.title) {
                this.steps.design = true
            } else {
                this.steps.design = false
            }
            if (this.page.description.length > 0) {
                localStorage.newPageDescription = JSON.stringify(this.page.description)
            } else {
                localStorage.newPageDescription = ''
            }
        },
        visibleBubble() {
            this.visibleB = !this.visibleB
        },
        changeColorScheme(payload) {
            if (this.page.description && this.page.title) {
                this.steps.design = true
            } else {
                this.steps.design = false
            }
            this.page.dark = payload.value
            localStorage.newPageDark = payload.id
        },
        changeButtonText(payload) {
            if (this.page.description && this.page.title) {
                this.steps.design = true
            } else {
                this.steps.design = false
            }
            this.page.buttonText = payload.name
            this.page.button = payload.id
            localStorage.newPageButton = payload.id
        },
        updateSteps(payload) {
            this.list = payload
            let localFlag = false
            this.list.map(item => {
                if (item.check.inputs.length > 0) {
                    localFlag = true
                }
            })
            if (localFlag) {
                this.steps.gate = true
            } else {
                this.steps.gate = false
            }
            this.page.steps = payload
            localStorage.newPageSteps = JSON.stringify(this.page.steps)
            return this.page.steps
        },
        checkPixel() {
            this.pixelTouch = true
            if (this.pixel) {
                this.steps.pixel = true
            } else {
                this.steps.pixel = false
            }
            localStorage.newPixel = JSON.stringify(this.pixel)

        },
        touchAll() {
            this.projectNameTouch = true
            this.titleTouch = true
            this.urlTouch = true
            this.pixelTouch = true
            this.descTouch = true
        },
        confirm() {
            this.page.name = this.projectName.inp
            this.page.url = this.url.inp
            this.page.pixel = this.pixel
            const data = {
                'content': this.page
            }
            localStorage.removeItem("newPageTitle")
            localStorage.removeItem("newPageDescription")
            localStorage.removeItem("newPageButton")
            localStorage.removeItem("newPageDark")
            localStorage.removeItem("newProjectName")
            localStorage.removeItem("image_size")
            localStorage.removeItem("image_name")
            localStorage.removeItem("newPageSteps")
            this.$store.dispatch('updateContent', data).then(resp => {
                this.$router.push('/my-gates')
            })
        },
        contentById() {
            this.update = true
            const id = this.$route.params.id
            this.$store.dispatch('contentById', {id, full: true})
                .then(resp => {
                        const item = resp.data
                        this.projectName = {inp: item.name, invalide: false, error: false}
                        this.pixel = item.pixel
                        this.url = {inp: item.url, invalide: false, error: false}
                        this.page = item
                        if (item.steps.length > 0) {
                            localStorage.newPageSteps = JSON.stringify(item.steps)
                            this.page.steps = item.steps
                        } else {
                            this.page.steps = this.defaultSteps
                        }
                        this.selected.button = this.buttons[item.button - 1]
                        this.page.button = this.buttons[item.button - 1]
                        this.changeButtonText(this.page.button)
                        let schemeIdx;

                        if (item.dark) {
                            schemeIdx = 1
                        } else {

                            schemeIdx = 0

                        }
                        this.changeColorScheme(this.colorScheme[schemeIdx])
                        this.selected.colorScheme = this.colorScheme[schemeIdx]
                        this.page.dark = this.colorScheme[schemeIdx].value
                        this.update = false


                    }
                )
        }


    },
    mounted() {
        this.contentById()
    },
    computed: {
        checkAll() {
            this.touchAll()
            if (this.steps.name && this.steps.content && this.steps.design && this.steps.pixel) {
                this.allRight = true
                return true
            } else {
                this.allRight = false
                return false
            }
        },
        demoSrc() {
            return this.url.inp
        },
    },
    created() {
    },
    watch: {
        page: 'checkAll',
        $route: 'contentById'
    }
}
